import { FC } from 'react';

import { PlusSubscriptionModal } from 'src/components/plusSubscription/modals/components/Modal';

export const PlusSubscriptionUpgradePage: FC = () => <PlusSubscriptionModal type="planSelection" />;
